import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo/logo.png";

const NavBar = () => {
	return (
		<header className="site-header">
			<NavLink exact to="/" className="site-logo" aria-label="NY Engineering Home">
				<img src={logo} alt="NY Engineering Structural Engineering" />
			</NavLink>
			<nav className="site-nav" aria-label="Main navigation">
				<NavLink exact to="/" activeClassName="active">Home</NavLink>
				<NavLink to="/projects" activeClassName="active">Projects</NavLink>
				<NavLink to="/services" activeClassName="active">Services</NavLink>
				<NavLink to="/about" activeClassName="active">The Firm</NavLink>
				<NavLink to="/contact" activeClassName="active">Contact</NavLink>
			</nav>
		</header>
	);
};

export default NavBar;
